export default "__VITE_ASSET__CzH4WoOE__"